// Function to toggle dark mode
const toggleDarkMode = (): void => {
    const darkModeToggle = document.getElementById('dark-mode-toggle');
    const htmlElement = document.documentElement;
    
    if (darkModeToggle) {
        darkModeToggle.addEventListener('click', () => {
            htmlElement.classList.toggle('dark');
            
            // Update localStorage
            if (htmlElement.classList.contains('dark')) {
                localStorage.setItem('darkMode', 'enabled');
                darkModeToggle.innerHTML = '<i class="fas fa-sun"></i> Light Mode';
            } else {
                localStorage.setItem('darkMode', 'disabled');
                darkModeToggle.innerHTML = '<i class="fas fa-moon"></i> Dark Mode';
            }
        });
    }
};

// Function to set initial dark mode state
const setInitialDarkMode = (): void => {
    const darkModeToggle = document.getElementById('dark-mode-toggle');
    const htmlElement = document.documentElement;
    const darkMode = localStorage.getItem('darkMode');
    
    if (darkMode === 'enabled') {
        htmlElement.classList.add('dark');
        if (darkModeToggle) {
            darkModeToggle.innerHTML = '<i class="fas fa-sun"></i> Light Mode';
        }
    }
};

// Smooth scrolling for navigation links
const smoothScroll = (): void => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (this: HTMLAnchorElement, e: Event) {
            e.preventDefault();
            const href = this.getAttribute('href');
            if (href) {
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
};

// Initialize functions when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    smoothScroll();
    toggleDarkMode();
    setInitialDarkMode();
});
